import type { BuilderElement } from '@/utils/builder/types';
import { generateId } from '@/utils/builder/id-utils';

const createDefaultNameInput = (): BuilderElement => {
  return {
    id: generateId(),
    type: 'input',
    name: 'username',
    placeholder: 'Enter your name',
    styles: {
      width: '100%',
      padding: '12px',
      margin: '8px 0',
      borderRadius: '4px',
      border: '1px solid tertiary',
      fontSize: '16px',
    },
    _isNew: true,
    _needsSync: true,
  };
};

const createDefaultEmailInput = (): BuilderElement => {
  return {
    id: generateId(),
    type: 'input',
    name: 'useremail',
    placeholder: 'Enter your email',
    styles: {
      width: '100%',
      padding: '12px',
      margin: '8px 0',
      borderRadius: '4px',
      border: '1px solid tertiary',
      fontSize: '16px',
    },
    _isNew: true,
    _needsSync: true,
  };
};

const createDefaultSubmitButton = (): BuilderElement => {
  return {
    id: generateId(),
    type: 'button',
    isSubmitButton: true,
    content: 'Submit',
    styles: {
      backgroundColor: 'primary',
      color: 'background',
      padding: '12px 24px',
      borderRadius: '4px',
      fontWeight: 'bold',
      fontSize: '16px',
      border: 'none',
      cursor: 'pointer',
      margin: '16px 0',
    },
    _isNew: true,
    _needsSync: true,
  };
};

export const createDefaultFormElement = (): BuilderElement => {
  const id = generateId();

  return {
    id,
    type: 'form',
    href: '#',
    target: 'POST',
    styles: {
      backgroundColor: 'background',
      padding: '20px',
      margin: '10px 0',
      borderRadius: '8px',
      border: '1px solid tertiary',
    },
    children: [
      createDefaultNameInput(),
      createDefaultEmailInput(),
      createDefaultSubmitButton(),
    ],
    _isNew: true,
    _needsSync: true,
  };
};

